import http from './http' // needs this file in the same directory

export default {
  index(){
    return http.get(`/contracts`);
  },

  show(item_id){
    return http.get(`/contracts/`+item_id);
  },

  create(new_item){
    return http.post(`/contracts`,{
      contract:{ 
        name:              new_item.name,
        parts:             new_item.parts,
        total_ammount:     new_item.total_ammount? new_item.total_ammount.replace(/,/g, '') : null,
        payed_until:       new_item.payed_until,
        start_date:        new_item.start_date,
        end_date:          new_item.end_date,
        initial_fee_paid:  new_item.initial_fee_paid,
        initial_fee_value: new_item.initial_fee_value? new_item.initial_fee_value.replace(/,/g, '') : null,
        ammount_payed:     new_item.ammount_payed? new_item.ammount_payed.replace(/,/g, '') : null,
        final_fee:         new_item.final_fee,
        final_fee_type:    new_item.final_fee_type,
        comment:           new_item.comment,
      }
    });
  },

  update(update_item){
    return http.put(`/contracts/${update_item.id}`,{
      contract:{ 
        id: update_item.id,

        name:              update_item.name,
        parts:             update_item.parts,
        total_ammount:     update_item.total_ammount? update_item.total_ammount.replace(/,/g, '') : null,
        payed_until:       update_item.payed_until,
        start_date:        update_item.start_date,
        end_date:          update_item.end_date,
        initial_fee_value: update_item.initial_fee_value? update_item.initial_fee_value.replace(/,/g, '') : null,
        initial_fee_paid:  update_item.initial_fee_paid,
        ammount_payed:     update_item.ammount_payed? update_item.ammount_payed.replace(/,/g, '') : null,
        final_fee:         update_item.final_fee,
        final_fee_type:    update_item.final_fee_type,
        comment:           update_item.comment,
      }
    });
  },

  updateToDelete(update_item){
    return http.delete(`/contracts/${update_item}`);
  },

}